import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n.jsx";
import { PageHeader, Empty } from "../components/Bits";
import TransInput from "../components/TransInput";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { toast } from "sonner";
import { Plus, Archive } from "lucide-react";

export default function ConfigPage({ entity }) {
  const { t, tn } = useI18n();
  const [rows, setRows] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState({});
  const [editId, setEditId] = useState(null);
  const titleKey = entity === "positions" ? "positions" : "units";

  const load = () => api.get(`/config/${entity}`).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [entity]);

  const open = (row) => { if (row) { setEditId(row.id); setName(row.name); } else { setEditId(null); setName({}); } setModal(true); };
  const save = async () => {
    try {
      const body = { name }; if (entity === "units") body.key = (name.en || "u").toLowerCase().replace(/\s/g, "");
      if (editId) await api.put(`/config/${entity}/${editId}`, { name }); else await api.post(`/config/${entity}`, body);
      toast.success(t("save")); setModal(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || t("error")); }
  };
  const archive = async (id) => { await api.delete(`/config/${entity}/${id}`); load(); };

  return (
    <div>
      <PageHeader title={t(titleKey)} subtitle={`${rows.length}`}
        action={<Button data-testid="add-config-btn" onClick={() => open(null)} className="bg-[var(--amber)] hover:bg-[var(--amber-2)] text-white gap-2"><Plus size={16} /> {t("create")}</Button>} />
      {rows.length === 0 ? <Empty /> : (
        <div className="tactical-card divide-y divide-[var(--border)]">
          {rows.map((r) => (
            <div key={r.id} data-testid={`config-${r.id}`} className="flex items-center gap-3 px-4 py-3">
              <span className="flex-1 font-semibold">{tn(r.name)}</span>
              <button onClick={() => open(r)} className="text-[var(--blue)] text-sm" data-testid={`config-edit-${r.id}`}>{t("edit")}</button>
              <button onClick={() => archive(r.id)} className="text-[var(--red)]" data-testid={`config-archive-${r.id}`}><Archive size={15} /></button>
            </div>
          ))}
        </div>
      )}
      <Dialog open={modal} onOpenChange={setModal}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editId ? t("edit") : t("create")} — {t(titleKey)}</DialogTitle></DialogHeader>
          <TransInput value={name} onChange={setName} placeholder={t("name")} />
          <DialogFooter>
            <Button variant="outline" onClick={() => setModal(false)}>{t("cancel")}</Button>
            <Button onClick={save} className="bg-[var(--amber)] text-white" data-testid="config-save">{t("save")}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
